export function getdata() {
	var obj = {
		
			headData: [{
					title: "序号",
					prop: "grade",
					width: "50px",
					custom: true,
		
				}, {
					title: "税种",
					prop: "ccxwyh_0_x_1",
					
					width: "100px",
					custom: true,
				},
				{
					title: "税目",
					prop: "ccxwyh_0_x_2",
					
					custom: true,
					width: "100px",
				},
				{
					title: '税款',
					children: [{
						title: '所属期起',
						prop: 'ccxwyh_0_x_3',
					
					width: "100px",
						custom: true,
					}, ]
				},
				{
					title: '税款',
					children: [{
						title: '所属期止',
						prop: 'ccxwyh_0_x_4',
					
					width: "100px",
						custom: true,
					}]
				},
				{
					title: "计税依据",
					prop: "ccxwyh_0_x_5",
					
					custom: true,
					width: "100px",
				}, {
					title: "税率",
					prop: "ccxwyh_0_x_6",
					
					custom: true,
					width: "100px",
				},{
					title: "应纳税额",
					prop: "ccxwyh_0_x_7",
					
					custom: true,
					width: "100px",
				}, {
					title: "减免税额",
					prop: "ccxwyh_0_x_8",
					
					custom: true,
					width: "100px",
				}, {
					title: "已缴税额",
					prop: "ccxwyh_0_x_9",
					
					custom: true,
					width: "100px",
				}, {
					title: "应补（退）税额",
					prop: "ccxwyh_0_x_10",
					
					custom: true,
					width: "100px",
				},
			],
			tableData: [{
					grade: '1',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_1_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_1_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_1_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_1_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_1_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_1_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_1_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_1_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_1_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				},
				{
					grade: '2',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_2_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_2_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_2_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_2_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_2_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_2_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_2_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_2_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_2_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}, {
					grade: '3',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_3_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_3_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_3_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_3_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_3_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_3_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_3_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_3_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_3_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}, {
					grade: '4',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_4_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_4_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_4_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_4_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_4_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_4_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_4_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_4_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_4_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_4_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}, {
					grade: '5',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_5_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_5_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_5_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_5_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_5_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_5_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_5_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_5_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_5_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_5_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}, {
					grade: '6',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_6_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_6_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_6_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_6_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_6_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_6_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_6_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_6_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_6_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}, {
					grade: '7',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_7_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_7_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_7_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_7_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_7_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_7_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_7_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_7_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_7_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_7_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}, {
					grade: '8',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_8_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_8_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_8_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_8_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_8_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_8_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_8_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_8_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_8_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_8_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}, {
					grade: '9',
					disabledccxwyh_0_x_1: true,
					disabledccxwyh_0_x_2: true,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_9_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_9_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_9_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_9_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_9_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_9_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_9_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_9_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_9_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_9_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}, {
					grade: '10',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_10_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_10_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_10_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_10_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_10_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_10_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_10_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_10_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_10_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_10_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}, {
					grade: '11',
					disabledccxwyh_0_x_1: false,
					disabledccxwyh_0_x_2: false,
					disabledccxwyh_0_x_3: false,
					disabledccxwyh_0_x_4: false,
					disabledccxwyh_0_x_5: false,
					disabledccxwyh_0_x_6: false,
					disabledccxwyh_0_x_7: false,
					disabledccxwyh_0_x_8: false,
					disabledccxwyh_0_x_9: false,
					disabledccxwyh_0_x_10: false,
					ccxwyh_0_x_1: {
						cellCode: " ccxwyh_0_11_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_2: {
						cellCode: " ccxwyh_0_11_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_3: {
						cellCode: " ccxwyh_0_111_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_4: {
						cellCode: " ccxwyh_0_11_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_5: {
						cellCode: " ccxwyh_0_11_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_6: {
						cellCode: " ccxwyh_0_11_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_7: {
						cellCode: " ccxwyh_0_11_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_8: {
						cellCode: " ccxwyh_0_11_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_9: {
						cellCode: " ccxwyh_0_11_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwyh_0_x_10: {
						cellCode: " ccxwyh_0_11_10",
						cellType: "1",
						cellVal: "240040043.08"
					}
				}
			]
		
	}
	return obj
}
